import GeneralSettingView from '../../components/GeneralSettingView';

GeneralSettingScreen.propTypes = {};

function GeneralSettingScreen(props) {
    return (
        <div className="container-fluid px-4 my-4">
            <GeneralSettingView showFullUI={true} />
        </div>
    );
}

export default GeneralSettingScreen;
